export const SUCCESS = `
<style>
        #checkContainer{
                position: relative;
                display: flex;
                align-items: center;
                height: 64px;
                width: 44px;
            }
            #haloCircle{
                position: absolute;
                height: 42px;
                width: 42px;
                border-radius: 100%;
                background-color: #CAF1E1;
                border: 1px solid #2BD994;
                opacity: 0;
                animation: haloAnimation1 .22s ease-in 0.6s 1 forwards, haloAnimation2 .42s ease-in-out 1.6s 1 forwards;
                animation-fill-mode: forwards;
            }
            #filledCircle{
                position: absolute;
                height: 44px;
                width: 44px;
                border-radius: 100%;
                background-color: #2BD994;
                animation: filledCircleAnimation 1s 1 ease-in-out;
                opacity: 0;
                animation-fill-mode: forwards;
            }
            #check1{
                position: absolute;
                background-color: white;
                border-radius: 4px;
                height: 3.5px;
                width: 3.5px;
                rotate: 45deg;
                translate: 13px 0px;
                opacity: 0;
                animation: checkAnimation1 .3s ease-in-out 1s 1 normal forwards;
                transform-origin: 0px 0px
            }
            #check2{
                position: absolute;
                background-color: white;
                border-radius: 4px;
                height: 3.5px;
                width: 3.5px;
                rotate: -45deg;
                translate: 16.5px 7.8px;
                opacity: 0;
                animation: checkAnimation2 .3s ease-in-out 1.3s 1 normal forwards;
                transform-origin: 0px 0px
            }
            @keyframes haloAnimation1 {
                0% {
                    scale: 0.1;
                    opacity: 0;
                }
                100%{
                    scale: 1;
                    opacity: 1;
                }
            }
            @keyframes haloAnimation2 {
                0% {
                    scale: 1;
                    opacity: 1;
                }
                100% {
                    scale: 1.4;
                    opacity: 0;
                }
            }
            @keyframes filledCircleAnimation {
                0% {
                }
                90% {
                    scale: 0.1;
                    opacity: 0;
                }
                100% {
                    scale: 1;
                    opacity: 1;
                }
            }
            @keyframes checkAnimation1{
                0%{
                    opacity: 0;
                }
                20%{
                    opacity: 1;
                }
                100%{
                    width: 11px;
                    opacity: 1;
                }
            }
            @keyframes checkAnimation2{
                0%{
                    opacity: 0;
                }
                20%{
                    opacity: 1;
                }
                100%{
                    width: 19.4px;
                    opacity: 1;
                }
            }
</style>
 <div id="checkContainer">
 <div id="haloCircle"></div>
 <div id="filledCircle"></div>
 <div id="check1"></div>
 <div id="check2"></div>
 </div>
`
